import React, { useState } from "react";
import { Chip } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import InfoCard from "../../../components/ui/InfoCard";
import AddEditPersonalModal from "../../ProfileSettings/PersonalInformation/components/AddEditPersonalModal";
import { formatPhoneNumber } from "../../../utils/helpers";

dayjs.extend(relativeTime);

const UserInformation = ({ userInfo, refetchMe, canEdit = false }) => {
  const [editOpen, setEditOpen] = useState(false);

  return (
    <>
      <InfoCard
        title="User Info"
        actions={
          <>
            {canEdit && (
              <i
                className="fa-light fa-pencil text-gray-900 cursor-pointer"
                onClick={() => setEditOpen(true)}
              ></i>
            )}
            <Chip label="Active" color="success" size="small" className="w-24 justify-center" />
          </>
        }
        items={[
          ["Legal Name", userInfo?.name],
          ["Email", userInfo?.email],
          ["Cell Phone", formatPhoneNumber(userInfo?.phoneNumber)],
          // A missing date would otherwise render as "now".
          [
            "Created On",
            userInfo?.createdAt && dayjs(userInfo.createdAt).format("YYYY/MM/DD hh:mm A"),
          ],
          ["Last Active", userInfo?.lastActive && dayjs(userInfo.lastActive).fromNow()],
        ]}
      />

      {/* The edit modal carries its own mutations and settings-module imports, so it
          is only mounted for a viewer who can actually open it. */}
      {canEdit && (
        <AddEditPersonalModal
          open={editOpen}
          close={() => setEditOpen(false)}
          userId={userInfo?.userId}
          initialValues={{
            firstName: userInfo?.firstName,
            lastName: userInfo?.lastName,
            email: userInfo?.email,
            phoneNumber: userInfo?.phoneNumber,
          }}
          refetchMe={refetchMe}
        />
      )}
    </>
  );
};

export default UserInformation;
